import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import styles from "./style";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from './config/firebase';

import Homepage from './pages/Homepage';
import SignInPage from './pages/authentication/SignInPage';
import SignUpPage from './pages/authentication/SignUpPage';
import NavigationHeader from './components/NavigationHeader';
import Footer from './components/Footer';

import MainDashboard from './pages/Dashboard/MainDashboard';
import DashboardHeader from './pages/Dashboard/DashboardHeader';
import Asset from './pages/Dashboard/Asset';
import Inventory from './pages/Dashboard/Inventory';
import StreetSurfacePage from './pages/Dashboard/StreetSurfacePage';

import FirebaseTest from './pages/authentication/FirebaseTest';
import AdminBugReportDashboard from './pages/TicketSystem/AdminBugReportDashboard';

const App = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      if (currentUser) {
        localStorage.setItem('isLoggedIn', 'true');
      } else {
        localStorage.removeItem('isLoggedIn');
      }
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  // Private Route Component
  const PrivateRoute = ({ element, ...rest }) => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    return isLoggedIn ? element : <Navigate to="/signin" />;
  };

  // Show NavigationHeader if user is not logged in or on specific public routes
  const showNavigationHeader = !user || ['/signin', '/signup'].includes(location.pathname);

  // Show DashboardHeader if user is logged in and not on public routes
  const showDashboardHeader = user && !['/signin', '/signup', '/dashboard'].includes(location.pathname);

  return (
    <div>
      {showNavigationHeader && (
        <div className={`${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <NavigationHeader />
          </div>
        </div>
      )}

      {showDashboardHeader && (
        <div className={`${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <DashboardHeader />
          </div>
        </div>
      )}

      <div>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/dashboard" element={<PrivateRoute element={<MainDashboard />} />} />
          <Route path="/asset" element={<PrivateRoute element={<Asset />} />} />
          <Route path="/inventory" element={<PrivateRoute element={<Inventory />} />} />
          <Route path="/streetsurface" element={<PrivateRoute element={<StreetSurfacePage />} />} />
          <Route path="/firebase" element={<PrivateRoute element={<FirebaseTest />} />} />
          <Route path="/report" element={<PrivateRoute element={<AdminBugReportDashboard />} />} />
        </Routes>
      </div>

      {showNavigationHeader && (
        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
          <Footer />
        </div>
      )}
    </div>
  );
};

export default App;
